import { Cascader, DatePicker, Button, Select, Table, Modal } from "antd";
import { useCallback, useRef, useState } from "react";
import "./index.styl";
const { RangePicker } = DatePicker;

export default function InpurtStatusSearch() {
  const searchContent = useRef("");
  const learnStatus = useRef("");
  const smartBeans = useRef(0);

  const options = [
    {
      value: "1",
      label: "村名",
      children: [
        {
          value: "1",
          label: "中医村02期",
        },
      ],
    },
  ];

  const dataSource = [
    {
      key: "1",
      member: "丁大侠",
      timestamp: "2024.5.17 21:34:21",
      module: "天空训练营",
      uploadNums: "20",
      failedNums: 6,
    },
  ];

  const columns = [
    {
      title: "操作人",
      dataIndex: "member",
      key: "member",
    },
    {
      title: "操作时间",
      dataIndex: "timestamp",
      key: "timestamp",
    },
    {
      title: "操作板块",
      dataIndex: "module",
      key: "module",
    },
    {
      title: "上传数量",
      dataIndex: "uploadNums",
      key: "uploadNums",
    },
    {
      title: "失败数量",
      dataIndex: "failedNums",
      key: "failedNums",
    },
  ];

  // 主列表分页属性
  const paginationProps = {
    showSizeChanger: true,
    showQuickJumper: false,
    showTotal: () => `共${6}条`,
    // pageSize: this.state.pageSize,
    current: 1,
    total: 6,
    // onShowSizeChange: (current, pageSize) =>
    //   this.changePageSize(pageSize, current),
    onChange: (current) => this.changePage(current),
  };

  const onSearchTimeChanged = useCallback((val) => {
    console.log(val);
  }, []);

  const onLearnStatusChanged = useCallback((val) => {}, []);

  const onSmartBeansChanged = useCallback((val) => {}, []);

  return (
    <div className="container">
      <div className="searchContainer">
        <div className="searchInputContainer">
          <div className="searchItem">
            操作人：
            <Select
              defaultValue={"1"}
              style={{ width: 120 }}
              onChange={onSmartBeansChanged}
              options={[{ value: "1", label: "丁大虾" }]}
            />
          </div>
          <div className="searchItem">
            时间范围：
            <RangePicker
              format="YYYY-MM-DD"
              onChange={(value, dateString) => {
                console.log("Selected Time: ", value);
                console.log("Formatted Selected Time: ", dateString);
              }}
              onOk={onSearchTimeChanged}
            />
          </div>
          <div className="searchItem">
            操作板块：
            <Select
              defaultValue=""
              style={{ width: 120 }}
              onChange={onLearnStatusChanged}
              options={[{ value: "0", label: "天空营" }]}
            />
          </div>
          <Button className="searchItem" type="primary">
            查询
          </Button>
        </div>
      </div>

      <div className="contentContainer">
        <Table
          onRow={(record) => {
            console.log(record);
            return {
              onClick: (event) => {
                console.log(event);
              },
            };
          }}
          dataSource={dataSource}
          columns={columns}
        />
      </div>
    </div>
  );
}
